import triangleIndicator from '../../../../../assets/image/validation-score/triangleIndicator.svg';

type ValidationLetterProps = {
  letter: string;
};

const LETTER_GROUPS = [
  {
    id: 1,
    color: '#77EBB5',
    items: ['A1', 'A2', 'A3'],
    label: 'ریسک خیلی پایین',
  },
  {id: 2, color: '#AFEBCF', items: ['B1', 'B2', 'B3'], label: 'ریسک پایین'},
  {id: 3, color: '#FEDF89', items: ['C1', 'C2', 'C3'], label: 'ریسک متوسط'},
  {id: 4, color: '#FFC38E', items: ['D1', 'D2', 'D3'], label: 'ریسک بالا'},
  {id: 5, color: '#FDA29B', items: ['E1', 'E2', 'E3'], label: 'ریسک خیلی بالا'},
];

const ValidationLetter = ({letter}: ValidationLetterProps) => {
  return (
    <div className="flex relative gap-1 items-end">
      {LETTER_GROUPS.flatMap(group =>
        group.items.map(item => {
          const isActive = item === letter;

          return (
            <div key={item} className="flex relative flex-col items-center">
              {/* Indicator + label */}
              {isActive && (
                <div
                  className={`absolute flex flex-col  -top-16  whitespace-nowrap 
                    ${group.id == 1 && 'items-start right-1'} 
                    ${group.id == 5 && 'items-end left-1'} 
                    ${[2, 3, 4].includes(group.id) && 'items-center'} 
                    `}
                >
                  <span className="text-sm font-medium">{item}</span>
                  <span className="text-sm font-medium">{group.label}</span>
                  <img
                    src={triangleIndicator}
                    className="mt-1 w-3"
                    alt="indicator"
                  />
                </div>
              )}

              {/* Letter box */}
              <div
                className="flex items-center justify-center w-[14px] h-[14px] text-[10px] font-medium rounded"
                style={{backgroundColor: group.color}}
              >
                {item}
              </div>
            </div>
          );
        }),
      )}
    </div>
  );
};

export default ValidationLetter;
